import { Page } from '@/core/architecture'

import { ConsoleCampaignDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleCampaignDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleCampaignDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleCampaignDetailTemplate state={state} {...actions} />
}
